import React, { useEffect, useState } from 'react';
import LevelListing from './LevelListing';
import { columnTypes } from 'src/components/UI/atoms/ATMTable/ATMTable';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import { setIsOpenAddDialog, setIsOpenEditDialog, setPage, setRowsPerPage, setSearchValue,setIsTableLoading,setItems,setTotalItems} from 'src/redux/slices/LevelSlice';
import ATMMenu from 'src/components/UI/atoms/ATMMenu/ATMMenu';
import { showConfirmationDialog } from 'src/utils/showConfirmationDialog';
import { showToast } from 'src/utils/showToaster';
import AddLevelWrapper from '../Add/AddLevelWrapper';
import { useChangeStatusLevelByIdMutation, useDeleteLevelByIdMutation, useGetAllLevelDataQuery } from 'src/services/LevelService';
import EditLevelWrapper from '../Edit/EditLevelWrapper';
import { usePermission } from 'src/hooks/usePermission';

type Props = {};

const LevelListingWrapper = (props: Props) => {
    const dispatch = useDispatch();
    const { items, totalItems, page, rowsPerPage, searchValue, isOpenAddDialog, isOpenEditDialog, isTableLoading } =
        useSelector((state: RootState) => state.level);


    const [deleteLevel] = useDeleteLevelByIdMutation()
    const [changeStatusLevel] = useChangeStatusLevelByIdMutation()

    const [selectedLevelId, setSelectedLevelId] = useState<string>()
    const { data, isLoading, isFetching } = useGetAllLevelDataQuery({
        limit: rowsPerPage,
        searchValue: searchValue,
        params: [
            "levelName",
        ],
        page: page,
        filterBy: [],
        dateFilter: {},
        orderBy: "createdAt",
        orderByValue: -1,
        isPaginationRequired: true,
    });

    // Setting Module Data
    useEffect(() => {
        if (isLoading || isFetching) {
            dispatch(setIsTableLoading(true));
        } else {
            dispatch(setItems(data?.data || []));
            dispatch(setIsTableLoading(false));
            dispatch(setTotalItems(data?.totalItem || 0));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, isLoading, isFetching]);

    const handleDeleteLevel = (row: string) => {
        showConfirmationDialog({
            title: "Hands Up",
            text: "Are you sure want to delete this Level ?",
            icon: "question",
            showCancelButton: true,
            next: (result) => {
                if (result?.isConfirmed) {
                    deleteLevel(row).then((res: any) => {
                        if (res.error) {
                            showToast("error", res?.error?.data?.message);
                        } else {
                            showToast("success", res?.data?.message);
                        }
                    });
                }
            },
        });
    };


    const handleChangeStatusLevel = (row: string) => {
        showConfirmationDialog({
            title: "Hands Up",
            text: "Are you sure want to change status of this Level ?",
            icon: "question",
            showCancelButton: true,
            next: (result) => {
                if (result?.isConfirmed) {
                    changeStatusLevel({id : row}).then((res: any) => {
                        if (res.error) {
                            showToast("error", res?.error?.data?.message);
                        } else {
                            showToast("success", res?.data?.message);
                        }
                    });
                }
            },
        });
    };

const moduleName = "LEVEL";

const canEdit = usePermission(moduleName, "UPDATE");
const canDelete = usePermission(moduleName, "DELETE");
const canActive = usePermission(moduleName, "ACTIVE/DEACTIVE");

    const columns: columnTypes[] = [
  { field: 'levelName', headerName: 'Level Name', flex: 'flex-[1_1_0%]' },
  {
    field: "action",
    headerName: "Actions",
    flex: "flex-[1_1_0%]",
    align:"end",
    extraClasses: "",
    renderCell: (row: any) => {
      const options = [];

      if (canEdit) {
        options.push({
          label: "Edit",
          onClick: () => {
            dispatch(setIsOpenEditDialog(true));
            setSelectedLevelId(row?._id);
          },
        });
      }

      if (canActive) {
        options.push({
          label: "Active/Deactive",
          onClick: () => {
            handleChangeStatusLevel(row?._id);
          },
        });
      }

      if (canDelete) {
        options.push({
          label: "Delete",
          onClick: () => {
            handleDeleteLevel(row?._id);
          },
        });
      }

      return <ATMMenu options={options} />;
    },
  },
];

    return (
        <>
            <div>
                <LevelListing
                    columns={columns}
                    rows={items}
                    paginationProps={{
                        isTableLoading,
                        totalItems,
                        page,
                        rowsPerPage,
                        searchValue,
                        setPage: (newPage) => dispatch(setPage(newPage)),
                        setRowsPerPage: (newRowsPerPage) => dispatch(setRowsPerPage(newRowsPerPage)),
                        setIsOpenAddDialog: (value) => dispatch(setIsOpenAddDialog(value)),
                        setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
                    }}
                />
            </div>
            {isOpenAddDialog ? (
                <AddLevelWrapper
                    onClose={() => dispatch(setIsOpenAddDialog(false))}
                />
            ) : null}
            {isOpenEditDialog ? (
                <EditLevelWrapper
                    onClose={() => dispatch(setIsOpenEditDialog(false))}
                    selectedLevelId ={selectedLevelId || ""}
                />
            ) : null}
        </>
    );
};

export default LevelListingWrapper;